import { defineStore } from "pinia";

// Single source of truth for which marker layers are visible in the 3D viewer.
// Previously this lived in three places at once (AnomalyToolBar's *Hidden refs,
// ViewAsset.inspectionAreaZonesVisible, and ModelViewer's *Visible flags), which
// could desync. The toolbar toggles these; ModelViewer reads them to set mesh visibility.
export const useViewerUiStore = defineStore("viewerUi", {
  state: () => ({
    layers: {
      anomalies: true,
      hotspots: true,
      // The "walking path" polyline traced through each scan's camera positions — visual aid for
      // orienting the user against how the capture was filmed. ModelViewer builds the lines.
      // Hidden by default; the user turns it on from the layer toggles when they want it.
      walkingPath: false,
      zones: false,
      cameras: false,
    },
  }),
  actions: {
    toggleLayer(key) {
      this.layers[key] = !this.layers[key];
    },
    reset() {
      this.layers = {
        anomalies: true,
        hotspots: true,
        walkingPath: false,
        zones: false,
        cameras: false,
      };
    },
  },
});
